import React, { useEffect, useState } from "react"

import { Link, useNavigate } from "react-router-dom"

import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu"
import logo from "../../assets/images/logo.svg"
import logoLightSvg from "../../assets/images/logo-light.svg"
import menuBurger from "../../assets/images/icons/menu-burger-icon.svg"
import circleCheck from "../../assets/images/icons/circle-check.svg"
import circleCheckBlue from "../../assets/images/icons/circle-check-blue.svg"
import { useDispatch, useSelector } from "react-redux"
import GlobalSearch from "components/investorSearch/globalSearch"
import { setSidebar } from "store/slices/userSlice"
import NotificationDropdown from "components/CommonForBoth/TopbarDropdown/NotificationDropdown"

import { usePermission } from "hooks/usePermission"
import { PERMISSIONS } from "helpers/roles"
import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap"
import { setCurrentUserMenuType } from "store/slices/commonSlice"
import GetInTouch from "components/investorSearch/getInTouch"

const Header = () => {
  const { userType, sidebar } = useSelector((state) => state.user)
  const { currentUserMenuType } = useSelector((state) => state.common)
  const { hasAnyPermission } = usePermission()
  const [mobileMenuOpen, setmobileMenuOpen] = useState(false)
  const [open, setOpen] = useState(false)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    if (window.innerWidth <= 998 && sidebar) {
      dispatch(setSidebar({ sidebar: false }))
    }
  }, [])

  function tToggle() {
    const body = document.body
    if (window.innerWidth <= 998) {
      if (document.body.classList.contains("sidebar-enable")) {
        dispatch(setSidebar({ sidebar: false }))
      } else {
        dispatch(setSidebar({ sidebar: true }))
      }
      body.classList.toggle("sidebar-enable")
    } else {
      body.classList.toggle("vertical-collpsed")
      body.classList.toggle("sidebar-enable")
    }
  }

  const changeMenuType = (type) => {
    dispatch(setCurrentUserMenuType(type))
    navigate("/dashboard")
    setTimeout(() => {
      window.location.reload()
    }, 500)
    setmobileMenuOpen(false)
  }

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex align-items-center">
            <div className="navbar-brand-box d-lg-none d-md-block">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logo} alt="" height="22" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logoLightSvg} alt="" height="22" />
                </span>
              </Link>
            </div>
            <button
              type="button"
              onClick={() => {
                tToggle()
              }}
              className="btn btn-sm px-1 px-md-3 font-size-16 header-item "
              id="vertical-menu-btn"
            >
              {/* <img src={menuBurger} alt="menuBurger" height={"25px"} /> */}
              <img
                src={menuBurger}
                alt="menuBurger"
                height={"25px"}
                onClick={() => setOpen(!open)}
                style={{
                  cursor: "pointer",
                  transform: open ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.3s ease",
                }}
              />
            </button>
            {userType === "ADMIN" && (
              <div
                className="d-none d-md-flex"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <p
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                    backgroundColor:
                      currentUserMenuType === "INVESTOR"
                        ? "#F0A735"
                        : "#FFFFFF80",
                    borderRadius: "30px",
                    fontSize: "14px",
                    fontWeight: "500",
                    color:
                      currentUserMenuType === "INVESTOR" ? "#fff" : "#065697",
                    padding: "6px 30px",
                    cursor: "pointer",
                    minWidth: "200px",
                    textAlign: "center",
                    margin: "0px auto",
                  }}
                  onClick={() => changeMenuType("INVESTOR")}
                >
                  <img
                    src={
                      currentUserMenuType === "INVESTOR"
                        ? circleCheck
                        : circleCheckBlue
                    }
                    alt=""
                  />
                  <span>Investor</span>
                </p>

                <p
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                    backgroundColor:
                      currentUserMenuType === "WEALTH_PARTNER"
                        ? "#F0A735"
                        : "#FFFFFF80",
                    borderRadius: "30px",
                    fontSize: "14px",
                    fontWeight: "500",
                    color:
                      currentUserMenuType === "WEALTH_PARTNER"
                        ? "#fff"
                        : "#065697",
                    padding: "6px 30px",
                    cursor: "pointer",
                    minWidth: "200px",
                    textAlign: "center",
                    margin: "0px auto",
                  }}
                  onClick={() => changeMenuType("WEALTH_PARTNER")}
                >
                  <img
                    src={
                      currentUserMenuType === "WEALTH_PARTNER"
                        ? circleCheck
                        : circleCheckBlue
                    }
                    alt=""
                  />
                  <span> Wealth Partner</span>
                </p>
              </div>
            )}
            {userType === "ADMIN" && (
              <div className="filter d-block d-md-none">
                <Dropdown
                  isOpen={mobileMenuOpen}
                  toggle={() => setmobileMenuOpen(!mobileMenuOpen)}
                >
                  <DropdownToggle
                    style={{
                      backgroundColor: "#FFFFFF80",
                      borderRadius: "30px",
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#065697",
                      padding: "6px 10px",
                      cursor: "pointer",
                      textAlign: "center",
                      margin: "0px auto",
                      minWidth: "120px",
                      width: "100%",
                    }}
                  >
                    {currentUserMenuType === "INVESTOR"
                      ? "Investor"
                      : "Wealth Partner"}
                  </DropdownToggle>
                  <DropdownMenu
                    style={{
                      padding: "10px 10px",
                      width: "fit-content",
                      borderRadius: "16px",
                    }}
                  >
                    <p
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        backgroundColor:
                          currentUserMenuType === "INVESTOR"
                            ? "#F0A735"
                            : "#8ccbff",
                        color:
                          currentUserMenuType === "INVESTOR"
                            ? "#fff"
                            : "#065697",
                        borderRadius: "30px",
                        fontSize: "14px",
                        fontWeight: "500",
                        padding: "6px 20px",
                        cursor: "pointer",
                        textAlign: "center",
                        margin: "0px auto",
                        width: "200px",
                      }}
                      onClick={() => changeMenuType("INVESTOR")}
                    >
                      <img
                        src={
                          currentUserMenuType === "INVESTOR"
                            ? circleCheck
                            : circleCheckBlue
                        }
                        alt=""
                      />
                      <span>Investor</span>
                    </p>
                    <p
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        backgroundColor:
                          currentUserMenuType === "WEALTH_PARTNER"
                            ? "#F0A735"
                            : "#8ccbff",
                        color:
                          currentUserMenuType === "WEALTH_PARTNER"
                            ? "#fff"
                            : "#065697",
                        borderRadius: "30px",
                        fontSize: "14px",
                        fontWeight: "500",
                        padding: "6px 20px",
                        cursor: "pointer",
                        textAlign: "center",
                        margin: "10px auto 0px auto",
                        width: "200px",
                      }}
                      onClick={() => changeMenuType("WEALTH_PARTNER")}
                    >
                      <img
                        src={
                          currentUserMenuType === "WEALTH_PARTNER"
                            ? circleCheck
                            : circleCheckBlue
                        }
                        alt=""
                      />
                      <span> Wealth Partner</span>
                    </p>
                  </DropdownMenu>
                </Dropdown>
              </div>
            )}
          </div>
          <div className="d-flex align-items-center gap-3">
            {userType !== "ADMIN" && (
              <>
                <GlobalSearch />
                <GetInTouch />
              </>
            )}
            <NotificationDropdown />
            <ProfileMenu />
          </div>
        </div>
      </header>
    </React.Fragment>
  )
}

export default Header
